module.exports = __webpack_public_path__ + "img/babywearing.951589bc.jpg";